export default "__VITE_ASSET__Cv$74FR9__"